import React, { Component } from 'react';
import { StyleSheet, View, Text, TouchableWithoutFeedback, PixelRatio } from 'react-native';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  popBackground: {
    width: '60%',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    borderRadius: 10,
    backgroundColor: '#fff',
  },
  warp: {
    paddingVertical: 10,
    paddingHorizontal: 20,
  },
  title: {
    marginTop: 10,
    marginBottom: 6,
    fontSize: 16,
    fontWeight: 'bold',
    alignSelf: 'center',
  },
  content: {
    fontSize: 14,
    alignSelf: 'center',
    marginBottom: 10,
  },
  btn: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const ModelConfrim = (props) => {
  let { title, content, cancelBtn, okBtn, callback, app } = props;
  title = title || '提 示';
  content = content || '您确定此操作？';
  cancelBtn = cancelBtn || '取消';
  okBtn = okBtn || '确定';

  const onClickCancel = () => {
    app.hidePopModal();
  };

  const onClickOK = () => {
    app.hidePopModal();
    callback();
  };

  return (
    <View style={styles.container}>
      <View style={styles.popBackground}>
        <View style={styles.warp}>
          <Text style={styles.title}>{title}</Text>
          <Text style={styles.content}>{content}</Text>
        </View>
        <View style={{ flexDirection: 'row', alignSelf: 'stretch', height: 40, borderTopColor: '#999', borderTopWidth: 1 / PixelRatio.get() }}>
          <TouchableWithoutFeedback onPress={onClickCancel}>
            <View style={[styles.btn, { borderRightColor: '#999', borderRightWidth: 1 / PixelRatio.get() }]}>
              <Text style={{ color: 'rgb(29, 111, 235)', fontSize: 16 }}>{cancelBtn}</Text>
            </View>
          </TouchableWithoutFeedback>
          <TouchableWithoutFeedback onPress={onClickOK}>
            <View style={styles.btn}>
              <Text style={{ color: 'rgb(29, 111, 235)', fontSize: 16 }}>{okBtn}</Text>
            </View>
          </TouchableWithoutFeedback>
        </View>
      </View>
    </View >
  );
};
export default ModelConfrim;
